"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const popover_1 = require("../styles/popover");
const utils_1 = require("../utils");
const hooks_1 = require("../utils/hooks");
const mixpanel_1 = require("../utils/mixpanel");
const cart_items_1 = require("./cart-items");
const cost_breakdown_1 = __importDefault(require("./cost-breakdown"));
const expired_footer_1 = __importDefault(require("./expired-footer"));
const footer_1 = __importDefault(require("./footer"));
const mapExpiredGroup = (data) => {
    var _a, _b;
    if (!(data === null || data === void 0 ? void 0 : data.recoverable_items))
        return [];
    return [
        {
            group_id: 0,
            campaign_name: '',
            items: (_b = (_a = data.recoverable_items) === null || _a === void 0 ? void 0 : _a.item_list) !== null && _b !== void 0 ? _b : [],
        },
    ];
};
const mapGroups = (data) => {
    var _a;
    if (data === null || data === void 0 ? void 0 : data.lastItemAdded)
        return [
            {
                group_id: 0,
                campaign_name: '',
                items: (data === null || data === void 0 ? void 0 : data.lastItemAdded) ? [(0, utils_1.mapOrderPipeLoyaltyToProxyItem)(data === null || data === void 0 ? void 0 : data.lastItemAdded)] : [],
            },
        ];
    return (_a = data.cart_item_groups) !== null && _a !== void 0 ? _a : mapExpiredGroup(data);
};
const Cart = ({ data, status, onRouting }) => {
    var _a, _b, _c;
    (0, hooks_1.useViewTrackEvent)(mixpanel_1.FloatingCartRender, data);
    if (!data.cart_item_groups && !data.recoverable_items && !data.cart_loyalty_product && !data.lastItemAdded)
        return null;
    const groups = (data.cart_item_groups || data.recoverable_items) && mapGroups(data);
    const loyalty = data.cart_loyalty_product || (data.lastItemAdded && (0, utils_1.mapOrderPipeLoyaltyToProxy)(data.lastItemAdded));
    const isExpired = status === provider_1.ResponseCode.EXPIRED;
    return ((0, jsx_runtime_1.jsxs)(popover_1.PopoverContainer, { isReopenOrder: (_b = (_a = data === null || data === void 0 ? void 0 : data.metadata) === null || _a === void 0 ? void 0 : _a.show_reopen) !== null && _b !== void 0 ? _b : false, isNewItem: false, children: [(0, jsx_runtime_1.jsx)(cart_items_1.CartItems, { groups: groups, loyalty: loyalty, isExpired: isExpired, onRouting: onRouting, cartType: data === null || data === void 0 ? void 0 : data.cart_type }), (0, jsx_runtime_1.jsx)(cost_breakdown_1.default, { cart: data, isExpired: isExpired }), !isExpired ? ((0, jsx_runtime_1.jsx)(footer_1.default, { cart: data, onRouting: onRouting })) : ((0, jsx_runtime_1.jsx)(expired_footer_1.default, { showReopen: (_c = data === null || data === void 0 ? void 0 : data.metadata) === null || _c === void 0 ? void 0 : _c.show_reopen, onRouting: onRouting }))] }));
};
exports.default = Cart;
